









import {
  Component,
  Mixins,
  Prop,
  Ref,
  Vue,
  Watch,
} from 'vue-property-decorator'

@Component
export default class ImageInput extends Vue {
  @Prop({ type: String })
  private src!: string | null

  @Prop({ type: String })
  private fallbackSrc!: string | null

  private showImage = true
  private currentSrc = this.src

  // @Watch('src')
  // private srcChanged() {
  //   this.reload()
  // }

  private loadFallback() {
    this.currentSrc = this.fallbackSrc
  }

  // public reload() {
  //   this.showImage = false
  //   this.$nextTick(() => {
  //     this.showImage = true
  //   })
  // }
}
